import React, {Component} from 'react';
import './homeCustom.scss';
import chatbot from '../../../Assets/icons/google_ad.svg';
import onlineSupport from '../../../Assets/icons/online_world.svg';
import ticket from '../../../Assets/icons/it_support.svg';
import { NavLink } from "react-router-dom"
export default class homeCustom extends Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {};

    }
    handleStart = (type:string) => {
        let user:any=localStorage.getItem('UserData');
        if(!user){
            this.props.history.push(`/panel/login/`)
        }else {
            this.props.history.push(`/panel/${type}/`)
        }

    };
    handlePlan= (type:string) => {

        this.props.history.push('/register')
    };
    componentDidMount() {

    }

    render() {
        // const {articles} = this.state;

        return (
            <div className="HomePage">

                <header>
                    <div className="container px-20 py-20">
                        <nav className="right  Menu-Item-Animation" id="myTopnav"
                             style={{flex: 1}}>

                            {/*<a className="logo" href="#"><img*/}
                                {/*src="https://grandima.com/wp-content/uploads/2019/08/grandima-final-logo-p-300x277.png"/></a>*/}
                        
                              
                            <a href="#Services">Services</a>
                            <NavLink exact to="/login"  activeClassName="active">
                                <i className="mdi mdi-key pl-5"/> Login
                             </NavLink>
                            <span>/</span>

                            <NavLink exact to="/register"  activeClassName="active">
                                <i className="mdi mdi-account pl-5"/> Register
                             </NavLink>
                        

                        </nav>


                    </div>
                </header>


                <section className="banner"/>
                <div className="home animated fadeIn slow delay-1">

                    <div className="header">
                        <h1 className="color-white"> Socialytik</h1>
                        <h2 className="color-white"> is simply dummy  </h2>
                        <p className="m-auto description p-10 color-cyan">is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                    </div>

                    <div id="Services" className="brand pb-100 row reverse-md-down ">
                        <div className="col-md-6 px-100-sm-up px-20-sm-down">
                            <h2 className="color-indigo"> is simply dummy   </h2>
                            <p className="m-auto   color-gray-dark font-17">is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>

                            <button onClick={()=>this.handleStart('search')}
                                className=" font-17 w-50 btn-indigo pl-40 btn-icon"><i className="mdi mdi-arrow-left "/>
                                Start
                            </button>
                        </div>
                        <div className="col-md-6 m-auto text-center">
                            <img  src={chatbot}/>
                        </div>
                    </div>

                    <div className="brand pb-100 row">
                        <div className="col-md-6 m-auto text-center">
                            <img src={onlineSupport}/>
                        </div>
                        <div className="col-md-6 px-100-sm-up px-20-sm-down">
                            <h2 className="color-indigo"> is simply dummy   </h2>
                            <p className="m-auto   color-gray-dark font-17">is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>

                            <button onClick={()=>this.handleStart('search')}
                                className=" font-17 w-50 btn-indigo pl-40 btn-icon"><i className="mdi mdi-arrow-left "/>
                                Start
                            </button>
                        </div>
                    </div>


                    <div className="brand pb-100 row reverse-md-down ">
                        <div className="col-md-6 px-100-sm-up px-20-sm-down">
                            <h2 className="color-indigo"> is simply dummy   </h2>
                            <p className="m-auto   color-gray-dark font-17">is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>

                            <button  onClick={()=>this.handleStart('ticket')}
                                className=" font-17 w-50 btn-indigo pl-40 btn-icon"><i className="mdi mdi-arrow-left "/>
                                Start
                            </button>
                        </div>
                        <div className="col-md-6 m-auto text-center">
                            <img src={ticket}/>
                        </div>
                    </div>


                    {/*<div className="articles row p-30">*/}

                        {/*<div style={{width: '100%'}}>*/}
                            {/*<h2 className="p-15 text-center">User Plans</h2>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 p-15 ">*/}
                            {/*<div className=" card p-10 text-center">*/}
                                {/*<div className="logo m-auto p-40 ">*/}
                                    {/*<img className="w-50" src={pelan} />*/}
                                {/*</div>*/}
                                {/*<h3 className="color-indigo">Free</h3>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<button onClick={()=>this.handlePlan('free')}*/}
                                    {/*className=" font-17 w-60 btn-indigo pl-40 btn-icon"><i*/}
                                    {/*className="mdi mdi-arrow-left "/>Choose*/}
                                {/*</button>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 p-15 ">*/}
                            {/*<div className=" card p-10 text-center">*/}
                                {/*<div className="logo m-auto p-40 ">*/}
                                    {/*<img className="w-50" src={pelan}/>*/}
                                {/*</div>*/}
                                {/*<h3 className="color-indigo">Free</h3>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<button onClick={()=>this.handlePlan('basic')}*/}
                                    {/*className=" font-17 w-60 btn-indigo pl-40 btn-icon"><i*/}
                                    {/*className="mdi mdi-arrow-left "/>Choose*/}
                                {/*</button>*/}
                            {/*</div>ّ*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 p-15 ">*/}
                            {/*<div className=" card p-10 text-center">*/}
                                {/*<div className="logo m-auto p-40 ">*/}
                                    {/*<img className="w-50" src={pelan}/>*/}
                                {/*</div>*/}
                                {/*<h3 className="color-indigo"> Free</h3>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<button onClick={()=>this.handlePlan('advance')}*/}
                                    {/*className=" font-17 w-60 btn-indigo pl-40 btn-icon"><i*/}
                                    {/*className="mdi mdi-arrow-left "/>Choose*/}
                                {/*</button>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="col-md-3 p-15 ">*/}
                            {/*<div className=" card p-10 text-center">*/}
                                {/*<div className="logo m-auto p-40 ">*/}
                                    {/*<img className="w-50" src={pelan}/>*/}
                                {/*</div>*/}
                                {/*<h3 className="color-indigo"> Free</h3>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<p className="m-auto description p-10 color-gray-dark">......</p>*/}
                                {/*<button onClick={()=>this.handlePlan('enterprise')}*/}
                                    {/*className=" font-17 w-60 btn-indigo pl-40 btn-icon"><i*/}
                                    {/*className="mdi mdi-arrow-left "/> Choose*/}
                                {/*</button>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}

                </div>

                <footer>

                    <div className="copyright px-100-md-up py-5">
                        <div className="py-20">All rights reserved </div>
                        <div className="   py-20 ">
                            <span className="socialIcon px-5"><i className="icon mdi mdi-telegram"/> </span>
                            <span className="socialIcon px-5"><i className="icon mdi mdi-facebook"/> </span>
                            <span className="socialIcon px-5"><i className="icon mdi mdi-twitter"/> </span>
                            <span className="socialIcon px-5"><i className="icon mdi mdi-instagram"/></span>
                        </div>
                    </div>
                </footer>


            </div>
        );
    }
}
